<template lang="pug">
v-img(:src="urlImage" :gradient="gradient ? 'to bottom, rgba(0,0,0,.1),#161f2b85' : ''"
      class="rounded-circle"
      :loading="isLoading"
      @error="urlImage = '/static/nobody.jpg'"
)
  v-progress-circular(v-if="isLoading" indeterminate color="primary" size="30")
</template>
<script>
import { apiGet, notify } from '../util/general'
export default {
  nem : 'c_avatar_perfil',
  props : {
    path : {
      type   : String,
      default: ''
    },
    gradient : {
      type   : Boolean,
      default: false
    },
    isFetch : {
      type   : Boolean,
      default: false
    },
    usuario : {
      type   : String,
      default: ''
    }
  },
  data () {
    return {
      isLoading : false,
      urlImage : this.path ||  '/static/nobody.jpg'
    }
  },
  created () {
    var vm = this
    if (vm.isFetch) {
      vm.fetchGetDataUser()
    }
  },
  watch : {
    path : function (val) {
      var vm = this
      vm.urlImage = val || '/static/nobody.jpg'
    },
    usuario : function (val) {
      var vm = this
      console.log(val)
      vm.fetchGetDataUser()
    }
  },
  methods : {
    fetchGetDataUser () {
      var vm = this
      vm.isLoading = true
      var obj      = {
        usuario : vm.usuario
      }
      apiGet(vm, '/usuario/obtener', obj, function (data) {
        vm.urlImage = data.lista[0].foto || '/static/nobody.jpg'
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_avatar_perfil.vue?86fd7b18